import React from 'react'
import Edcard from '../components/Edcard';
export default function Education() {
  return (
    <>
    {/* <div className='Education'> */}
    <h2>Education:</h2>
    <Edcard title="MESWCOE" where="SPPU university,Pune" from="july 2021" to="Present"/>
    <Edcard title="HSC" where="Sangmeshwar College,Solapur" from="2019" to="2021"/>
    {/* </div> */}
    </>
  )
}


